export default function ({ app, redirect }) {
    // Check if the user is authenticated
    if (app.$auth.loggedIn) {
        console.log(app.$auth.user.signed_up_as_seller, ',,,,,,,,,,,,,,,,,,,,,,,')
        const userRole = app.$auth.user.signed_up_as_seller; // Replace 'role' with the actual property that stores the user's role in your store
        // Redirect based on user role
        if (userRole === 1) {
            return redirect('/profile/driver');
        } else if (userRole === 0) {
            return redirect('/profile/passenger');
        }
    }
}
